import React from "react";
import "./dhipaya_truck.css";

export default function DhipayaTruckCard({ onSelect }) {
  return (
    <div className="pkg-card dhipaya-truck">
      <div className="pkg-body">
        <h3>ประเภท 3 รถใหญ่ (รหัส 320–540)</h3>
        <p>ทิพยประกันภัย — สำหรับรถบรรทุก หัวลาก และ หางพ่วง</p>

        <ul className="pkg-list">
          <li>ความรับผิดต่อบุคคลภายนอก</li>
          <li>ชีวิต 500,000 บาท/คน  ทรัพย์สิน 1 ล้าน บาท/ครั้ง</li>
          <li>PA 100,000 / รักษา 100,000 / ประกันตัว 200,000</li>
          <li>เบี้ยเริ่มต้น 8,000 บาท</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
